function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useRef } from 'react';
import { IconButton } from '@cbhq/cds-web/buttons/IconButton';
import { Icon } from '@cbhq/cds-web/icons/Icon';
import { colorToVariable } from '../../../componentsThemeMap.js';
import { legacyButtonRadius } from '../../../constants.js';
import { useClickOutside } from '../../../hooks/useClickOutside.js';
import { useOnScroll } from '../../../hooks/useOnScroll.js';
import { SlideIn } from '../../../layout/SlideInContainer.js';
import { useGlobalMicrocopy } from '../../../providers/MicrocopyProvider.js';
import '../../../ui/Div/index.js';
import { Text } from '../../../ui/Text.js';
import { NAVBAR_BANNER_HEIGHT, NAVBAR_NAV_HEIGHT } from '../constants.js';
import { SearchInput } from './SearchInput.js';
import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import { Div } from '../../../ui/Div/Div.js';
function SubNavSearchBar({
  searchTags = [],
  hasBanner,
  onSearch,
  searchLabel
}) {
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showSearchBar = _useState2[0],
    setShowSearchBar = _useState2[1];
  const containerRef = useRef(null);
  const microcopies = useGlobalMicrocopy();
  useClickOutside(() => setShowSearchBar(false), containerRef, showSearchBar);
  useOnScroll({
    onScrollUp: () => setShowSearchBar(false),
    onScrollDown: () => setShowSearchBar(false),
    disabledUp: !showSearchBar,
    disabledDown: !showSearchBar
  });
  const bannerHeight = hasBanner ? NAVBAR_BANNER_HEIGHT : 0;

  // eslint-disable-next-line react-perf/jsx-no-new-function-as-prop -- TODO Fix this
  const handleSearch = nextTerm => {
    setShowSearchBar(false);
    if (onSearch) onSearch(nextTerm);
  };
  return /*#__PURE__*/jsxs(Div, {
    ref: containerRef,
    position: {
      sm: 'unset',
      md: 'relative'
    },
    children: [/*#__PURE__*/jsxs(Text, {
      height: 36,
      width: 220,
      spacing: 1,
      spacingStart: 5,
      variant: "label2",
      background: "gray5",
      color: "foregroundMuted",
      display: {
        sm: 'none',
        md: 'flex'
      }
      // eslint-disable-next-line react-perf/jsx-no-new-function-as-prop -- TODO Fix this
      ,

      onClick: () => setShowSearchBar(true),
      css: {
        borderRadius: legacyButtonRadius,
        cursor: 'text',
        border: '1px solid transparent',
        ':hover': {
          border: '1px solid',
          borderColor: colorToVariable('primary')
        },
        '> div': {
          top: 12,
          left: 14,
          position: 'absolute !important'
        }
      },
      children: [/*#__PURE__*/jsx(Icon, {
        name: "search",
        size: "s",
        color: "primary"
      }), searchLabel || microcopies.global.search]
    }), /*#__PURE__*/jsx(Div, {
      display: {
        md: 'none'
      },
      children: /*#__PURE__*/jsx(IconButton, {
        transparent: true,
        name: "search",
        variant: "primary"
        // eslint-disable-next-line react-perf/jsx-no-new-function-as-prop -- TODO Fix this
        ,

        onPress: () => setShowSearchBar(true)
      })
    }), showSearchBar && /*#__PURE__*/jsx(Div, {
      zIndex: 1,
      position: "absolute",
      left: {
        sm: 0,
        md: -120
      },
      width: {
        sm: '100%',
        md: 340
      },
      spacingHorizontal: {
        sm: 3,
        md: 0
      },
      top: {
        sm: bannerHeight + NAVBAR_NAV_HEIGHT + 9,
        md: 0
      },
      children: /*#__PURE__*/jsx(SlideIn, {
        children: /*#__PURE__*/jsxs(Div, {
          width: "100%",
          alignItems: "center",
          flexDirection: "column",
          background: "background",
          css: {
            borderRadius: legacyButtonRadius,
            border: '1px solid rgba(91, 99, 110, 0.2)',
            boxShadow: '0px 0px 23px rgba(0, 0, 0, 0.08)'
          },
          children: [/*#__PURE__*/jsx(Div, {
            width: "100%",
            spacingVertical: 1,
            spacingHorizontal: 2,
            flexDirection: "column",
            children: /*#__PURE__*/jsx(SearchInput, {
              onSearch: handleSearch,
              showSearchBar: showSearchBar,
              setShowSearchBar: setShowSearchBar
            })
          }), searchTags && /*#__PURE__*/jsx(Fragment, {
            children: /*#__PURE__*/jsx(Div, {
              maxWidth: 1200,
              width: "100%",
              flexDirection: "column",
              children: /*#__PURE__*/jsxs(Div, {
                flexDirection: "column",
                spacingHorizontal: 2,
                spacingVertical: {
                  sm: 1,
                  lg: 2
                },
                children: [/*#__PURE__*/jsx(Text, {
                  variant: "label1",
                  as: "p",
                  color: "foregroundMuted",
                  children: microcopies.global.suggestedTopics
                }), searchTags.map(({
                  label,
                  url
                }) => /*#__PURE__*/jsx(Div, {
                  spacingTop: 1,
                  maxWidth: 600
                  // eslint-disable-next-line react-perf/jsx-no-new-function-as-prop -- TODO Fix this
                  ,

                  onClick: () => handleSearch(url || ''),
                  children: /*#__PURE__*/jsx(Text, {
                    as: "p",
                    variant: "label2",
                    color: "foregroundMuted",
                    css: {
                      ':hover': {
                        color: colorToVariable('primary'),
                        cursor: 'pointer'
                      }
                    },
                    children: label
                  })
                }, label))]
              })
            })
          })]
        })
      })
    })]
  });
}
export { SubNavSearchBar };
//# sourceMappingURL=SubNavSearchBar.js.map
